<template>
  <svg view-box="0 0 16 16" width="16px" height="16px">
    <image
      y="0"
      x="0"
      xlink:href="../../assets/WiresharkDoc-16.png"
      height="16"
      width="16"
    />
    <path
      style="
        fill: none;
        stroke: #888a85;
        stroke-width: 1px;
        stroke-linecap: butt;
        stroke-linejoin: miter;
        stroke-opacity: 1;
      "
      d="m 1.5,0.5 0,15 13,0 0,-11 -4,-4 z"
    />
    <path
      d="m 13,13 -10,-10"
      style="
        fill: #2e3436;
        stroke: #2e3436;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: miter;
        stroke-miterlimit: 4;
        stroke-opacity: 1;
        stroke-dasharray: none;
      "
    />
    <path
      style="
        fill: #2e3436;
        stroke: #2e3436;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: miter;
        stroke-opacity: 1;
        stroke-miterlimit: 4;
        stroke-dasharray: none;
      "
      d="m 3,13 10,-10"
    />
  </svg>
</template>
